import dayjs from "dayjs";
import {
    VehicleGridType,
    CustomerSimpleType,
    DepartmentSimpleType,
    SecretarySimpleType,
    SelectedParametersType,
    UserPermissionsType,
    EventResponse,
    ManagerSimpleType,
    SelectedParametersSimpleType,
} from "../types/types";

import { TreeViewBaseItem } from "@mui/x-tree-view";

export const oldTotalTicketsUnresolvedLocalStorageKey = "old_total_pending_tickets";

export const managerDefault: ManagerSimpleType = {
    id: -1,
    name: "",
    reducedName: "",
    cnpj: "",
    activated: true
};

export const secretaryDefault: SecretarySimpleType = {
    id: -1,
    name: "",
    reducedName: "",
    cnpj: "",
};

export const departmentDefault: DepartmentSimpleType = {
    id: -1,
    name: "",
    reducedName: "",
    cnpj: "",
    customerId: -1,
    secretaryId: -1,
};

export const customerDefault: CustomerSimpleType = {
    id: -1,
    name: "",
    reducedName: "",
    cnpj: "",
    startDate: dayjs(),
    endDate: dayjs(),
    activated: true,
    managerId: -1,
    cpf: "",
    useCpf: false
};

export const parametersDefault: SelectedParametersType = {
    userId: -1,
    customer: customerDefault,
    secretary: secretaryDefault,
    department: departmentDefault,
};

export const parametersSimpleDefault: SelectedParametersSimpleType = {
    userId: -1,
    managerId: -1,
    customerId: -1,
    secretaryId: -1,
    departmentId: -1,
    name: "",
    reducedName: "",
    isViewingAll: false
};

export const vehicleGridDefault: VehicleGridType = {
    id: -1,
    utcZone: null,
    name: "",
    vehiclePlate: "",
    departmentSecretaryReducedName: "",
    satelliteImei: "",
    satelliteId: null,
    useSatellite: false,
    departmentReducedName: "",
    vehicleBrandName: "",
    vehicleModelName: "",
    vehicleTypeName: "",
    groups: [],
    vehicleColorName: "",
    deviceLastUpdate: dayjs().toString(),
    zonedDeviceLastUpdate: dayjs().toString(),
    zonedSatelliteLastUpdate: dayjs().toString(),
    satelliteLastUpdate: dayjs().toString(),
    deviceStatus: "offline",
    position: {} as any,
    deviceId: null,
    deviceImei: "",
    driverUnrecorded: "",
    driver: {
        id: -1,
        name: "",
        phone: "",
        isWhatsApp: false,
        driverIdentifier: "",
        driverDepartmentReducedName: "",
        driverCode1: "",
        driverCode2: "",
        driverCode3: "",
        driverCpf: "",
        driverCode: ""
    },
    alerts: [],
    hasAlerts: false,
};

export const userCustomerPermissionsDefault: Array<UserPermissionsType> = [
    {
        optionItemId: "1",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "2",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "3",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "4",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "9",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "12",
        canCreate: true,
        canView: true,
        canEdit: false,
        canDelete: false,
    },
    {
        optionItemId: "13",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "14",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "15",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "16",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "17",
        canCreate: true,
        canView: true,
        canEdit: false,
        canDelete: false,
    },
    {
        optionItemId: "18",
        canCreate: true,
        canView: true,
        canEdit: false,
        canDelete: false,
    },
    {
        optionItemId: "19",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "20",
        canCreate: false,
        canView: true,
        canEdit: false,
        canDelete: false,
    },
    {
        optionItemId: "21",
        canCreate: true,
        canView: false,
        canEdit: false,
        canDelete: false,
    },
    {
        optionItemId: "22",
        canCreate: true,
        canView: true,
        canEdit: false,
        canDelete: false,
    },
    {
        optionItemId: "25",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "26",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "27",
        canCreate: true,
        canView: true,
        canEdit: false,
        canDelete: false,
    }
];

export const userManagerPermissionsDefault: Array<UserPermissionsType> = [
    {
        optionItemId: "4",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "6",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "7",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "8",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "9",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "10",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "11",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "12",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "13",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "15",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "16",
        canCreate: true,
        canView: true,
        canEdit: true,
        canDelete: false,
    },
    {
        optionItemId: "22",
        canCreate: true,
        canView: true,
        canEdit: false,
        canDelete: false,
    },
    {
        optionItemId: "23",
        canCreate: false,
        canView: true,
        canEdit: false,
        canDelete: false,
    }
];

export const TECHNICIAN_MENU_IDS = ["9", "10", "11", "12", "15", "16", "17", "18", "22"];

export const userTechnicianPermissionsDefault: Array<UserPermissionsType> =
    TECHNICIAN_MENU_IDS.map((optionItemId) => ({
        optionItemId,
        canView: true,
        canCreate: ["9", "10", "11", "12", "16", "17", "18", "22"].includes(optionItemId),
        canEdit: ["9", "10", "11", "16"].includes(optionItemId),
        canDelete: false,
    }));

export const eventResponseDefault: EventResponse = {
    id: -1,
    name: "",
    eventDateTime: "",
    vehicle: {
        id: -1,
        name: "",
        vehiclePlate: "",
        deviceImei: "",
        useSatellite: false,
        satelliteImei: "",
        vehicleColorName: "",
        driverName: ""
    },
};

const permissionsContent = [
    { id: "canView", label: "Visualizar" },
    { id: "canCreate", label: "Criar" },
    { id: "canEdit", label: "Editar" },
];

export const PROFILE_ACESSES = {
    ADMIN: "1",
    DEVELOPER: "2",
    SUPPORT: "3",
    CUSTOMER_ADMIN: "4",
    DRIVER: "5",
    TECHNICIAN: "6"
};

export const CAMERA_COMMANDS = {
    DOWNLOAD_EVENT_MEDIA: {
        value: "download_event_media",
        description: "Download de mídia por evento",
    },
    START_VIDEOSTREAM: {
        value: "start_videostream",
        description: "Iniciar transmissão de vídeo ao vivo",
    },
    REQUEST_VIDEO: {
        value: "request_video",
        description: "Solicitar download de vídeo",
    },
    VIDEO_TIMELINE: {
        value: "video_timeline",
        description: "Linha do tempo de vídeos",
    },
    TAKE_PHOTO: {
        value: "take_photo",
        description: "Capturar foto",
    },
    PLAYBACK_VIDEO: {
        value: "playback_video",
        description: "Reprodução de vídeo gravado",
    },
};

export const CHECKLIST_TYPES = {
    OPERATIONAL_EXIT: {
        value: 1,
        key: "OPERACIONAL_SAIDA",
        nameDesc: "Operacional - Saída",
        description:
            "Checklist operacional realizado quando o motorista sai com o veículo",
    },

    OPERATIONAL_ENTRY: {
        value: 2,
        key: "OPERACIONAL_ENTRADA",
        nameDesc: "Operacional - Entrada",
        description:
            "Checklist operacional realizado quando o motorista retorna com o veículo",
    },

    INSTALLATION: {
        value: 3,
        key: "INSTALACAO",
        nameDesc: "Rastreamento - Instalação",
        description:
            "Checklist realizado durante a instalação de rastreador no veículo",
    },

    MAINTENANCE: {
        value: 4,
        key: "MANUTENCAO",
        nameDesc: "Manutenção - Qualquer natureza",
        description:
            "Checklist realizado quando o veículo é levado para manutenção",
    },
} as const;

export function getChecklistTypeByValue(
    value?: number
) {
    if (!value) return null;

    return Object.values(CHECKLIST_TYPES).find(
        (status) => status.value === value
    ) ?? null;
}

export const CHECKLIST_STATUS = {
    FIT: {
        value: 1,
        key: "APTO",
        nameDesc: "Apto",
        description: "Liberado para operação",
        color: "#81C784", // verde
    },
    ATTENTION: {
        value: 2,
        key: "ATENCAO",
        nameDesc: "Atenção",
        description: "Apto, mas com atenção. Nenhum item de segurança comprometido",
        color: "#FFB74D", // laranja
    },
    UNFIT: {
        value: 3,
        key: "NAO_APTO",
        nameDesc: "Inapto",
        description: "Não apto. Contém item de segurança com defeito",
        color: "#E57373", // vermelho
    },
} as const;

export function getChecklistStatusByValue(
    value?: number
) {
    if (!value) return null;

    return Object.values(CHECKLIST_STATUS).find(
        (status) => status.value === value
    ) ?? null;
}

export const MENUS_ITENS = {
    INITIALPAGE: "0",
    TRACKING: "1",
    GROUPS: "2",
    GEOFENCE: "3",
    DRIVERS: "4",
    CUSTOMERS: "6",
    SECRETARIES: "7",
    DEPARTMENTS: "8",
    VEHICLES: "9",
    DEVICES: "10",
    IDENTIFIERS: "11",
    COMMANDS: "12",
    ACCESSES: "13",
    SETTINGS: "14",
    REPORTS: "15",
    HELP_DESK: "16",
    TRANSFER_VEHICLE: "17",
    TRANSFER_DRIVER: "18",
    DRIVER_ACCESSES: "19",
    DASH_BOARD: "20",
    VIDEO_TELEMETRY: "21",
    CHECK_LIST: "22",
    LOGS: "23",
    BANNERS: "24",
    WORK_SCHEDULES: "25",
    ROUTES: "26",
    INTEREST_POINTS: "27"
};

export const itensCustomerPermissions: Array<TreeViewBaseItem> = [
    {
        id: "3",
        label: "Cercas virtuais",
        children: permissionsContent,
    },
    {
        id: "2",
        label: "Grupos",
        children: permissionsContent,
    },
    {
        id: "4",
        label: "Motoristas",
        children: permissionsContent,
    },
    {
        id: "9",
        label: "Veículos",
        children: permissionsContent,
    },
    {
        id: "13",
        label: "Sub-Acessos",
        children: permissionsContent,
    },
    {
        id: "14",
        label: "Configurações",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canEdit", label: "Editar" },
        ],
    },
    {
        id: "15",
        label: "Relatórios",
        children: [{ id: "canView", label: "Visualizar" }],
    },
    {
        id: "1",
        label: "Rastreamento",
        children: [{ id: "canView", label: "Visualizar" }],
    },
    {
        id: "16",
        label: "Suporte",
        children: permissionsContent,
    },
    {
        id: "17",
        label: "Transferir veículos",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canCreate", label: "Criar" },
        ],
    },
    {
        id: "18",
        label: "Transferir motoristas",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canCreate", label: "Criar" },
        ],
    },
    {
        id: "12",
        label: "Comandos",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canCreate", label: "Criar" },
        ],
    },
    {
        id: "19",
        label: "Acesso do condutor",
        children: permissionsContent,
    },
    {
        id: "20",
        label: "Painel de indicadores",
        children: [
            { id: "canView", label: "Visualizar" },
        ],
    },
    {
        id: "21",
        label: "Video telemetria",
        children: [
            { id: "canView", label: "Visualizar" },
        ],
    },
    {
        id: "22",
        label: "Checklist",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canCreate", label: "Criar" },
        ],
    },
    {
        id: "25",
        label: "Escalas de trabalho",
        children: permissionsContent,
    },
    {
        id: "26",
        label: "Rotas",
        children: permissionsContent,
    },
    {
        id: "27",
        label: "Pontos de interesse",
        children: [...permissionsContent, {id: "canDelete", label: "Excluir"}],
    }
];

export const itensManagerPermissions: Array<TreeViewBaseItem> = [
    {
        id: "10",
        label: "Dispositivos",
        children: permissionsContent,
    },
    {
        id: "11",
        label: "Identificadores",
        children: permissionsContent,
    },
    {
        id: "12",
        label: "Comandos",
        children: permissionsContent,
    },
    {
        id: "6",
        label: "Clientes",
        children: permissionsContent,
    },
    {
        id: "7",
        label: "Secretarias",
        children: permissionsContent,
    },
    {
        id: "8",
        label: "Departamentos",
        children: permissionsContent,
    },
    {
        id: "4",
        label: "Motoristas",
        children: permissionsContent,
    },
    {
        id: "9",
        label: "Veículos",
        children: permissionsContent,
    },
    {
        id: "13",
        label: "Acessos",
        children: permissionsContent,
    },
    {
        id: "16",
        label: "Suporte",
        children: permissionsContent,
    },
    {
        id: "17",
        label: "Transferir veículos",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canCreate", label: "Criar" },
        ],
    },
    {
        id: "18",
        label: "Transferir motoristas",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canCreate", label: "Criar" },
        ],
    },
    {
        id: "15",
        label: "Relatórios",
        children: [{ id: "canView", label: "Visualizar" }],
    },
    {
        id: "22",
        label: "Checklist",
        children: [
            { id: "canView", label: "Visualizar" },
            { id: "canCreate", label: "Criar" },
        ],
    },
    {
        id: "23",
        label: "Logs do sistema",
        children: [
            { id: "canView", label: "Visualizar" },
        ],
    },
];

export const defaultManangerProfiles = [
    {
        id: 1,
        name: "Administrador",
        description: "Para administradores do sistema",
    },
    {
        id: 2,
        name: "Desenvolvedor",
        description: "Para desenvolvedores do sistema",
    },
    {
        id: 3,
        name: "Suporte",
        description: "Para atendentes do sistema",
    },
    {
        id: 6,
        name: "Técnico",
        description: "Para técnicos de instalação e suporte",
    },
];

export const defaultCustomerProfiles = [
    {
        id: 4,
        name: "Gestor",
        description: "Para gestores do cliente",
    },
    {
        id: 5,
        name: "Condutor",
        description: "Para condutores do cliente",
    }
];
